import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { ServerUrls } from '../../app/ServerUrls';
import { Messages } from '../../codegen/Localize';
import { serverScheduleUrl, siteScheduleUrl } from '../../schedule/utils/ScheduleUtils';
import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { ISchedule } from '../ServerApi/types/ISchedule';
import { IErrorDetail } from './ContentActionNotification';
import { ServerService } from './ServerService';

export class ScheduleErrors {

  public static $inject = ['ServerService'];

  constructor(
    private ServerService: ServerService) { }

  public errorDetailsFor(scheduleErrorItem: IErrorItem<ISchedule>): IErrorDetail {
    return {
      itemName: scheduleErrorItem.item.name,
      itemUrl:
        scheduleErrorItem.error.code === SchedulingErrorCode.SchedulingScheduleNotFound
          ? null
          : this.scheduleUrl(scheduleErrorItem.item),
      errorMessage: this.errorMessageForItem(scheduleErrorItem)
    };
  }

  private scheduleUrl(schedule: ISchedule): string {
    return this.ServerService.sessionSiteId()
      ? this.siteUrl(schedule)
      : this.serverUrl(schedule);
  }

  private siteUrl(schedule: ISchedule): string {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteScheduleUrl(siteUrls, schedule.id, schedule.scheduledAction);
  }

  private serverUrl(schedule: ISchedule): string {
    return serverScheduleUrl(ServerUrls.getInstance(), schedule.id, schedule.scheduledAction);
  }

  private errorMessageForItem(errorItem: IErrorItem<ISchedule>) {
    return this.errorMessageFor(errorItem.error, errorItem.item.name);
  }

  public errorMessageFor(error: IError, scheduleName: string = '') {

    switch (error.code) {
      case SchedulingErrorCode.SchedulingScheduleNotFound:
        return Messages.errorScheduleNotFound({ SCHEDULE_NAME: L10n.elideIfLong(scheduleName) });
      case SchedulingErrorCode.SchedulingNameAlreadyExists:
        return Messages.errorScheduleNameAlreadyExists();
      case SchedulingErrorCode.SchedulingNameTooLong:
        return Messages.errorScheduleNameTooLong();
      default:
        return Messages.errorUnknown();
    }
  }

}

Module.instance().service('ScheduleErrors', ScheduleErrors);
